/**
 * Created by Ning Jiang on 2025-01-08.
 */

import {Emitter} from "pixi-particles";
import {ParticlesManager} from "../../../core/particles/ParticlesManager";
import {ElGordosRevenge} from "../../ElGordosRevenge";

export class BigWinParticles extends PIXI.Container {

    private _levelConfig:any[] = [
        {
            "alpha" : {
                "start" : 0.8,
                "end" : 0.1
            },
            "scale" : {
                "start" : 1,
                "end" : 1.2,
                "minimumScaleMultiplier" : 0.5
            },
            "color" : {
                "start" : "#ffffff",
                "end" : "#ffffff"
            },
            "speed" : {
                "start" : 150,
                "end" : 100,
                "minimumSpeedMultiplier" : 1
            },
            "acceleration" : {
                "x" : 0,
                "y" : -20
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : 270,
                "max" : 330
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : 50,
                "max" : 150
            },
            "lifetime" : {
                "min" : 3.5,
                "max" : 5
            },
            "blendMode" : "normal",
            "frequency" : 0.1,
            "emitterLifetime" : -1,
            "maxParticles" : 100,
            "pos" : {
                "x" : 0,
                "y" : 0
            },
            "addAtBack" : false,
            "spawnType" : "rect",
            "spawnRect" : {
                "x" : -820,
                "y" : 370,
                "w" : 1440,
                "h" : 200
            }
        },
        {
            "alpha" : {
                "start" : 0.8,
                "end" : 0.1
            },
            "scale" : {
                "start" : 1,
                "end" : 1.2,
                "minimumScaleMultiplier" : 0.5
            },
            "color" : {
                "start" : "#e6a48f",
                "end" : "#e6a48f"
            },
            "speed" : {
                "start" : 150,
                "end" : 100,
                "minimumSpeedMultiplier" : 1
            },
            "acceleration" : {
                "x" : 10,
                "y" : -30
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : 270,
                "max" : 330
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : 50,
                "max" : 150
            },
            "lifetime" : {
                "min" : 3.5,
                "max" : 5
            },
            "blendMode" : "normal",
            "frequency" : 0.085,
            "emitterLifetime" : -1,
            "maxParticles" : 100,
            "pos" : {
                "x" : 0,
                "y" : 0
            },
            "addAtBack" : false,
            "spawnType" : "rect",
            "spawnRect" : {
                "x" : -820,
                "y" : 370,
                "w" : 1440,
                "h" : 200
            }
        },
        {
            "alpha" : {
                "start" : 0.8,
                "end" : 0.1
            },
            "scale" : {
                "start" : 1,
                "end" : 1.2,
                "minimumScaleMultiplier" : 0.5
            },
            "color" : {
                "start" : "#e88564",
                "end" : "#e88564"
            },
            "speed" : {
                "start" : 150,
                "end" : 100,
                "minimumSpeedMultiplier" : 1
            },
            "acceleration" : {
                "x" : 20,
                "y" : -40
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : 270,
                "max" : 330
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : 50,
                "max" : 150
            },
            "lifetime" : {
                "min" : 3.5,
                "max" : 5
            },
            "blendMode" : "normal",
            "frequency" : 0.07,
            "emitterLifetime" : -1,
            "maxParticles" : 100,
            "pos" : {
                "x" : 0,
                "y" : 0
            },
            "addAtBack" : false,
            "spawnType" : "rect",
            "spawnRect" : {
                "x" : -820,
                "y" : 370,
                "w" : 1440,
                "h" : 200
            }
        },
        {
            "alpha" : {
                "start" : 0.8,
                "end" : 0.1
            },
            "scale" : {
                "start" : 1,
                "end" : 1.2,
                "minimumScaleMultiplier" : 0.5
            },
            "color" : {
                "start" : "#e65f33",
                "end" : "#e65f33"
            },
            "speed" : {
                "start" : 150,
                "end" : 100,
                "minimumSpeedMultiplier" : 1
            },
            "acceleration" : {
                "x" : 30,
                "y" : -50
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : 270,
                "max" : 330
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : 50,
                "max" : 150
            },
            "lifetime" : {
                "min" : 3.5,
                "max" : 5
            },
            "blendMode" : "normal",
            "frequency" : 0.05,
            "emitterLifetime" : -1,
            "maxParticles" : 100,
            "pos" : {
                "x" : 0,
                "y" : 0
            },
            "addAtBack" : false,
            "spawnType" : "rect",
            "spawnRect" : {
                "x" : -820,
                "y" : 370,
                "w" : 1440,
                "h" : 200
            }
        },
        {
            "alpha" : {
                "start" : 0.8,
                "end" : 0.1
            },
            "scale" : {
                "start" : 1,
                "end" : 1.2,
                "minimumScaleMultiplier" : 0.5
            },
            "color" : {
                "start" : "#cc4416",
                "end" : "#cc4416"
            },
            "speed" : {
                "start" : 150,
                "end" : 100,
                "minimumSpeedMultiplier" : 1
            },
            "acceleration" : {
                "x" : 40,
                "y" : -60
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : 270,
                "max" : 330
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : 50,
                "max" : 150
            },
            "lifetime" : {
                "min" : 3.5,
                "max" : 5
            },
            "blendMode" : "normal",
            "frequency" : 0.03,
            "emitterLifetime" : -1,
            "maxParticles" : 100,
            "pos" : {
                "x" : 0,
                "y" : 0
            },
            "addAtBack" : false,
            "spawnType" : "rect",
            "spawnRect" : {
                "x" : -820,
                "y" : 370,
                "w" : 1440,
                "h" : 200
            }
        }
    ];

    private _emitter:Emitter | null;

    constructor() {
        super();
    }

    public playLevel(level:number):void {
        this.stop();
        this._emitter = new Emitter(this, [
            ElGordosRevenge.assetLoader.getTextures("particles/spark_1")[0],
            ElGordosRevenge.assetLoader.getTextures("particles/spark_2")[0],
            ElGordosRevenge.assetLoader.getTextures("particles/spark_3")[0],
            ElGordosRevenge.assetLoader.getTextures("particles/spark_4")[0]
        ], this._levelConfig[level]);
        ParticlesManager.addEmitter(this._emitter);
    }

    public stop():void {
        if(this._emitter) {
            ParticlesManager.queueRemoveEmitter(this._emitter);
        }
        this._emitter = null;
    }
}